import { useEffect } from "react"
import { useRef } from "react"
import { Link, useParams, useSearchParams, useNavigate, useOutletContext } from "react-router-dom"
import { useComputed, useSignal, useSignalEffect } from "@preact/signals-react"

import Button from "react-bootstrap/esm/Button.js"
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Spinner from 'react-bootstrap/Spinner'
import Stack from 'react-bootstrap/Stack'

import DebugAccordion from "../../components/DebugAccordion"
import PageTitle from "../../components/PageTitle.jsx"

import { addNotification, NotificationTypes } from "../../stores/notification-store"
import useConfigTemplateData from "../../hooks/useConfigTemplate"
import { UpdateConfigTemplate } from "../../utils/api.js"

export default function ConfigTemplate() {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams()
    const debug = !!searchParams.get('debug')
    const { beId, configTemplateId } = useParams()
    const {config, accessToken, userPermissionsSummary, accordionData: sidebarAccordionData  } = useOutletContext()

    useEffect(() => {
        if (userPermissionsSummary.value && !userPermissionsSummary.value.canViewConfigTemplates) {
            addNotification('You are not authorized to view UTGs for this account.', NotificationTypes.ERROR, true)
            navigate(`/`)
        }
    }, [userPermissionsSummary.value])
        
    const canEditSignal = useComputed(() => {
        return userPermissionsSummary?.value?.canEditConfigTemplates
    })
    
    const { configTemplate, loading: configTemplateLoading, error: configTemplateError } = useConfigTemplateData(beId, configTemplateId, config, accessToken)
    const formRef = useRef(null)
    const configTemplateName = useSignal('')
    const configTemplateJson = useSignal('')

    useSignalEffect(() => {
        configTemplateName.value = configTemplate.value.name
        configTemplateJson.value = configTemplate.value.config ? JSON.stringify(JSON.parse(configTemplate.value.config), null, 2) : '{}'
    })
    const handleInput = (event, signalVariable) => {
        console.log(event.currentTarget.value)
        signalVariable.value = event.currentTarget.value
        configTemplate.value.name = configTemplateName.value
        configTemplate.value.config = configTemplateJson.value
    }

    const accordionData = [
        { name: 'Config Template', data: configTemplate },
        { name: 'Access Token', data: accessToken },    
        { name: 'App Config', data: config }
    ]

    const handleSave = (event) => {
        configTemplate.value.config = JSON.stringify(JSON.parse(configTemplateJson), null, 0)
        UpdateConfigTemplate(beId, configTemplate.value, config, accessToken)
            .then(result => {
                addNotification('The config tmeplate was successfully updated.', NotificationTypes.SUCCESS, true)
            })
            .catch(error => {
                console.log(error.toString())
                addNotification('Unable to update the config template', NotificationTypes.ERROR, false)
                return false
            })
    }
    


    if (configTemplateLoading.value) {
        return (
            <div className="d-flex justify-content-center">
                <Spinner className="mt-5 align-center" animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
        )
    }

    return (
        <>
        <Breadcrumb className="px-3 pt-1 bg-light">
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: `/be/${beId}/templates` }}>
                Config Template List
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Manage {configTemplate.value.name}</Breadcrumb.Item>
        </Breadcrumb>
        <Stack direction="horizontal" gap={3}>
            <PageTitle title='Manage Config Template' canEditSignal={canEditSignal} />
        </Stack>

        <Form ref={formRef} validated onSubmit={(event) => handleSave(event)}>

            <Form.Group as={Row} className="mb-3" controlId="ConfigTemplateName">
                <Form.Label column sm="2" className="text-end">Name:</Form.Label>
                <Col sm="10">
                    <Stack>
                        <Form.Control defaultValue={configTemplateName.value} onInput={(event) => handleInput(event, configTemplateName)} required type="text" readOnly={!canEditSignal.value} />
                        <Form.Control.Feedback type="invalid">Required</Form.Control.Feedback>
                    </Stack>
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="ConfigTemplateJson">
                <Form.Label column sm="2" className="text-end">JSON:</Form.Label>
                <Col sm="10">
                    <Stack>
                        <Form.Control as="textarea" row="30" style={{height: 500}} defaultValue={configTemplateJson.value} onInput={(event) => handleInput(event, configTemplateJson)} required type="text" readOnly={!canEditSignal.value} />
                        <Form.Control.Feedback type="invalid">Required</Form.Control.Feedback>
                    </Stack>
                </Col>
            </Form.Group>

            {canEditSignal.value && <Form.Group as={Row} className="mb-3" controlId="formUpdateButton">
                <Form.Label column sm="2" className="text-end"></Form.Label>
                <Col sm="10">
                    <Stack direction="horizontal" gap={3}>
                        <Button type="submit">Update</Button>
                        <Button variant="secondary" onClick={() => navigate(0)}>Cancel</Button>
                    </Stack>
                </Col>
            </Form.Group>}

        </Form>


        <DebugAccordion data={accordionData} debug={debug} />
        </>
    )
}